import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectionArguments } from '../../models/selection-arguments';

@Component({
    selector: 'ldw-status-select-dialog',
    templateUrl: './status-select-dialog.component.html',
    styleUrls: ['./status-select-dialog.component.css'],
    standalone: false
})
export class StatusSelectDialogComponent {
  dialogRef = inject<MatDialogRef<StatusSelectDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  statusHasChanged(args: SelectionArguments) {
    this.data = args.id;
  }

  okClick(): void {
    this.dialogRef.close(this.data);
  }

  cancelClick(): void {
    this.dialogRef.close();
  }
}
